import Bellefont81 from './Bellefont 8.webp'
import Bellefont82 from './Bellefont 8 (2).webp'


const Bellefont8images =[
Bellefont81,Bellefont82
]

export default Bellefont8images;